import React from "react";
import SimpaleBuilder from "../PageBuilder/SimpaleBuilder";
import BusinessCard from "./Components/BusinessCard";
const BusinessesView = () => {
    return <SimpaleBuilder id="bzns" apiId="hub" url="v1/businesses" itemBuilder={BusinessCard} gridClass="small-card-grid" />;
};

export default BusinessesView;
